import { ADD_DRIVER, DRIVER_ERROR, GET_DRIVERS, GET_DRIVER } from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";

// get driver by id
export const getDriver = (id) => async (dispatch) => {
  try {
    const res = await customAxios.get(`/api/admin/drivers/${id}`);
    dispatch({
      type: GET_DRIVER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DRIVER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// get drivers
export const getDrivers = () => async (dispatch) => {
  try {
    const res = await customAxios.get("/api/admin/drivers");
    dispatch({
      type: GET_DRIVERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DRIVER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// get all active vehicles
export const getAllDrivers = async () => {
  try {
    const res = await customAxios.get("/api/admin/drivers");
    return res.data;
  } catch (err) {
    return [];
  }
};

// Creates a driver, or overwrites an existing one when `edit` is set.
//
// Resolves to { ok, message }. Both screens confirm behind a dialog and report the
// outcome themselves, so the failure message goes back to the caller rather than to
// an alert raised behind the open dialog.
export const addDriver =
  (formdata, history, edit = false) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await customAxios.post(
        "/api/admin/drivers",
        formdata,
        config
      );
      dispatch({
        type: ADD_DRIVER,
        payload: res.data,
      });
      return { ok: true };
    } catch (err) {
      // A network failure carries no err.response at all, and reading .statusText off
      // it threw a second error inside the catch, swallowing the real one.
      const errors = err?.response?.data?.errors;
      const message = errors
        ? JSON.stringify(errors)
        : "Driver could not be saved. Please try again.";

      dispatch({
        type: DRIVER_ERROR,
        payload: { msg: err?.response?.statusText, status: err?.response?.status },
      });
      return { ok: false, message };
    }
  };
